import React, {forwardRef, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import {Button, Input} from "../../../../components";
import * as Yup from "yup";
import { emptyFn, validateRequired, validateLegalRut, rut } from '../../../../shared';
import styles from './BillInfoForm.module.scss';
import clsx from "clsx";
import { formatRut } from '../../../../shared/utils';

export const BillInfoForm = forwardRef((props, ref) => {
  const {billInfo, onSubmitAction, onCancelAction} = props;

  const onSubmit = useCallback((values, {setSubmitting}) => {
    if (onSubmitAction != null) {
      // setSubmitting(true);
      onSubmitAction(values);
    }
  }, [onSubmitAction]);

  const formFactory = useCallback(formProps => {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      setFieldValue
    } = formProps;

    return (
      <form onSubmit={handleSubmit}>
        <Input
          required
          label="RUT"
          placeholder="RUT"
          name="rut"
          onChange={handleChange}
          onBlur={event => {
            setFieldValue('rut', formatRut(values['rut']));
            return handleBlur(event);
          }}
          value={values.rut}
          error={errors.rut && touched.rut && errors.rut}
        />

        <Input
          required
          label="Razón Social"
          placeholder="Razón Social"
          name="businessType"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.businessType}
          error={errors.businessType && touched.businessType && errors.businessType}
        />

        <Input
          required
          label="Actividad Económica"
          placeholder="Actividad Económica"
          name="economicActivity"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.economicActivity}
          error={errors.economicActivity && touched.economicActivity && errors.economicActivity}
        />

        <Input
          required
          label="Dirección"
          placeholder="Calle, Número, Comuna"
          name="address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.address}
          error={errors.address && touched.address && errors.address}
        />

        <div className={clsx(styles.buttonActions, 'p-2')}>
          <Button label="Cancelar" onClick={onCancelAction} theme={{outline: true}}/>
          <Button type="submit" label="Guardar" disabled={isSubmitting}/>
        </div>
      </form>
    );
  }, [onCancelAction]);

  return useMemo(() => (
    <Formik
      initialValues={billInfo}
      validationSchema={
        Yup.object().shape({
          rut: validateLegalRut,
          businessType: validateRequired("La razón social es requerida."),
          economicActivity: validateRequired("La actividad económica es requerida."),
          address: validateRequired("La dirección es requerida."),
        })
      }
      onSubmit={onSubmit}>
      {formFactory}
    </Formik>
  ), [billInfo, formFactory, onSubmit]);
});

BillInfoForm.propTypes = {
  billInfo: PropTypes.object,
  onSubmitAction: PropTypes.func,
  onCancelAction: PropTypes.func,
}

BillInfoForm.defaultProps = {
  billInfo: {},
  onCancelAction: emptyFn()
}


export default BillInfoForm;
